import { Breadcrumbs, Group, Text } from '@mantine/core'
import { FC } from 'react'
import { Link } from 'react-router-dom'

import { usePageData } from '../legacy/PageData'
import classes from './PageTitle.module.css'

export const PageTitleBreadcrumb: FC = () => {
  const { pageTitle, pageBreadcrumbs } = usePageData()

  const items = pageBreadcrumbs?.map((item, index) => (
    <Link to={item.path} key={index} className={item.isActive ? classes.activeLink : classes.link}>
      {item.title}
    </Link>
  ))

  return (
    <Group>
      <Text className={classes.title}>{pageTitle}</Text>
      <Breadcrumbs>{items}</Breadcrumbs>
    </Group>
  )
}
